import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getToken, getRegToken } from "../../src/utils/services";
import toast from "react-hot-toast";
import { api, regApi } from "../../src/utils/queries";
import { useAuthProvider } from "../../context/AuthProvider";
import BlockedModal from "../Modal/BlockedModal";
export default function PrivateRoute({ children }) {
  const [authorized, setAuthorized] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const router = useRouter();
  //   const { isAuthenticated, isLoading } = useAuth();

  const publicRoutes = [
    "/login",
    "/register",
    "/reset",
    "/register/organization",
    "/confirmation",
    "/help/help-me",
    "/404",
    "/create-user",
    "/info/gift-aid",
    "/info/privacy",
    "/info/terms",
    "/",
    "/about",
    "/coming-soon",
    "/pricing",
    "/reset",
    "/reset/verification",
    "/reset/password",
  ];

  const pathIsNotPublic = publicRoutes.indexOf(router.pathname) == -1;
  const { user, verified, clearState } = useAuthProvider();
  api.interceptors.response.use(
    (response) => response,
    async function (error) {
      // console.log('ll')
      const token = sessionStorage.getItem("token");
      if (error.response?.data?.payload) {
        errorMessage = error.response.data.payload;
      }
      if (403 === error.response.status) {
        if (
          pathIsNotPublic &&
          token &&
          router.pathname !== "/register/verification" &&
          router.pathname !== "/register/organization/onboarding"
        ) {
          setBlocked(true);
        }
      }
      if (401 === error.response.status) {
        if (
          pathIsNotPublic &&
          token &&
          router.pathname !== "/register/verification" &&
          router.pathname !== "/register/organization/onboarding"
        ) {
          // setAuthorized(false)
          sessionStorage.removeItem("token");
          router.replace("/login");
          clearState();
        }
      }
      return Promise.reject(error);
    }
  );

  // // console.log(verified)

  regApi.interceptors.response.use(
    (response) => response,
    async function (error) {
      // console.log('ll')
      const token = sessionStorage.getItem("reg");
      if (error.response?.data?.payload) {
        errorMessage = error.response.data.payload;
      }
      if (401 === error.response.status) {
        if (
          pathIsNotPublic &&
          token &&
          (router.pathname == "/register/verification" ||
            router.pathname == "/register/organization/onboarding")
        ) {
          // setAuthorized(false)

          sessionStorage.removeItem("reg");
          router.replace("/login");
          clearState();
        }
      }
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    setAuthorized(false);
    const path = router.pathname;

    if (getToken() && path === "/login") {
      // Redirect route, you can point this to /login
      router.replace("/overview");
      return;
    }

    if (
      !getToken() &&
      !authorized &&
      pathIsNotPublic &&
      path !== "/register/verification" &&
      path !== "/register/organization/onboarding"
    ) {
      // Redirect route, you can point this to /login
      router.replace("/login");
      return;
    }

    if (
      !getRegToken() &&
      !authorized &&
      pathIsNotPublic &&
      (path == "/register/verification" ||
        path == "/register/organization/onboarding")
    ) {
      // Redirect route, you can point this to /login
      router.replace("/login");
      return;
    }

    if (
      (!user?.is_onboarded || !user?.has_completed_stripe_onboarding) &&
      path !== "/register/organization/onboarding" &&
      pathIsNotPublic &&
      verified
    ) {
      router.replace("/register/organization/onboarding");
      return;
    }

    setAuthorized(true);
  }, [authorized, pathIsNotPublic, router.pathname, user]);

  //   if (!authorized && pathIsProtected) {
  //     return <FullPageLoader />;
  //   }

  return (
    authorized && (
      <>
        {children}
        {
          user ?  <BlockedModal show={blocked} setShow={setBlocked} isCharityNotVerified={user?.type == 'organization' && !user?.charity_is_verified} /> : null
        }
       
      </>
    )
  );
}
